<template>
  <section class="mobile-menu">
    <close-button class="mobile-menu__close-button" @click="closeMenu"></close-button>
    <h2 class="mobile-menu__title">{{ $t('mobileMenu.title') }}</h2>

    <nav class="mobile-menu__links links">
      <router-link
        v-for="{ labelKey, route } of sections"
        :key="labelKey"
        :to="route"
        class="links__link"
        :class="{ 'links__link--active': route.hash === $route.hash }"
        @click.native="$emit('close')"
      >
        {{ $t(labelKey) }}
      </router-link>
    </nav>

    <p class="mobile-menu__footer">{{ displayCountry }} — {{ displayLocale }}</p>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import CloseButton from '@/components/common/CloseButton.vue';

import { displayNameMixin } from '@/mixins/displayNameMixin';

import { LOCALE_LABEL } from '@/constants/locale';
import { types } from '@/store/types';

export default {
  name: 'MobileHeaderMenu',
  components: { CloseButton },
  mixins: [displayNameMixin],
  props: {
    sections: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      selectedLocale: types.state.LOCALE
    }),
    ...mapGetters({
      selectedCountry: types.getters.DELIVERY_COUNTRY
    }),
    displayCountry() {
      return this.getCountryDisplayName(this.selectedCountry);
    },
    displayLocale() {
      return LOCALE_LABEL[this.selectedLocale];
    }
  },
  methods: {
    closeMenu() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';

.mobile-menu {
  --button-size: 40px;
  --icon-size: 11px;

  position: absolute;
  left: 0;
  top: 0;

  display: flex;
  flex-direction: column;

  height: var(--screen-height);
  width: 100%;
  padding: 36px 16px;
  background-color: $white-color;
  font-family: var(--u-font-family-Helvetica);
  z-index: 1;

  &__title {
    margin: 28px 0 31px;
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0;
    color: $tuatara-color;
  }

  &__footer {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.4px;
  }
}

.links {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &__link {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.4px;
    font-family: var(--u-font-family-Helvetica);

    color: $tuatara-color;
    text-decoration: none;
    text-transform: uppercase;

    &:not(:last-child) {
      margin-bottom: 32px;
    }

    &--active {
      font-weight: 700;
    }
  }
}
@media (min-width: 600px) {
  .mobile-menu {
    padding: 56px 16px;
  }
}
</style>
